export const SplitIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1061_13693)">
      <path
        d="M10.365 7.1601C10.175 6.9601 9.86 6.9501 9.66 7.1351C9.46 7.3251 9.45 7.6401 9.635 7.8401L10.715 9.0001H7.42C6.98 9.0001 6.565 8.8101 6.28 8.4751L4.155 6.0001L6.28 3.5251C6.565 3.1901 6.98 3.0001 7.42 3.0001H10.715L9.635 4.1601C9.445 4.3601 9.46 4.6801 9.66 4.8651C9.755 4.9551 9.88 5.0001 10 5.0001C10.135 5.0001 10.265 4.9451 10.365 4.8401L11.56 3.5601C12.145 2.9751 12.145 2.0251 11.57 1.4501L10.365 0.160103C10.175 -0.0398971 9.86 -0.0498971 9.66 0.135103C9.46 0.325103 9.45 0.640103 9.635 0.840103L10.715 2.0001H7.42C6.69 2.0001 5.995 2.3201 5.52 2.8751L3.27 5.5001H0.5C0.225 5.5001 0 5.7251 0 6.0001C0 6.2751 0.225 6.5001 0.5 6.5001H3.27L5.52 9.1251C5.995 9.6801 6.685 10.0001 7.42 10.0001H10.715L9.635 11.1601C9.445 11.3601 9.46 11.6801 9.66 11.8651C9.755 11.9551 9.88 12.0001 10 12.0001C10.135 12.0001 10.265 11.9451 10.365 11.8401L11.56 10.5601C12.145 9.9751 12.145 9.0251 11.57 8.4501L10.365 7.1551V7.1601Z"
        fill="#41395C"
      />
    </g>
    <defs>
      <clipPath id="clip0_1061_13693">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
